import React, { useState, useContext, useMemo, useEffect, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { IconRefresh } from "../../../svg";
import { useTable, useSortBy, useFilters } from "react-table";
import { StyledWipDiarioPage } from "../../../styled-components/StyledWipDiarioPage.style";
import Swal from "sweetalert2";
import { getEmpresas } from '../../../services/empresas';
import { DynamicSelect } from "../../../components/DynamicSelect";
import { ToggleSwitchFilters } from "../../../components/ToggleSwitchFilters";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import logo from "../../../assets/criterio-experts.png";
const ExcelJS = require('exceljs');

const getLista = async (formValues) => {
    let list = null;
    let params = "";

    if (formValues.dataCorte) {
        params += `&DataCorte=${moment(formValues.dataCorte).startOf('day').format('YYYY-MM-DD 23:59:59')}`;
    }

    if (formValues.todosProcessos) {
        params += `&TodosProcessos=${formValues.todosProcessos}`;
    }

    params += `&idEmpresa=${formValues.idEmpresa}`;
    try {
        const response = await api.get(`wip/mensal?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}

export const WIPMensal = () => { 
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;

    const [searched, setSearched] = useState(false);
    const [ListaData, setListaData] = useState([]);
    const [TotaisData, setTotaisData] = useState(null);
    const [empresaList, setEmpresaList] = useState([]);
    const [dataCorte, setDataCorte] = useState(null);
    const [todosProcessos, setTodosProcessos] = useState(true);

    const toggleTodosProcessos = { name: 'toggleTodosProcessos', label: 'Todos os Processos', id: 'toggleTodosProcessos', status: todosProcessos, checked: todosProcessos };

    const { handleSubmit } = useForm();
    const formSubmit = async (data) => {
        loadTable(data);
    }

    var [isLoading, setisLoading] = useState(false);
    var [idEmpresa, setEmpresaId] = useState(null);
    var [selectedEmpresa, setselectedEmpresa] = useState(null);
    var [columns, setColumns] = useState([]);

    useEffect(() => {
        const asyncFn = async () => {
            const empresas = localStorage.getItem('empresasUsuario') ? JSON.parse(localStorage.getItem('empresasUsuario')) : [];
            const empresaList = await getEmpresas();
            if (!!empresaList) {
                setEmpresaList(empresaList.filter(empresa => empresas.indexOf(empresa.idEmpresa) > -1))
            }            

            const userEmpresas = JSON.parse(localStorage.getItem('empresasUsuario'));
            if (userEmpresas.length > 1) {
                setselectedEmpresa(null);
                setEmpresaId(null);
            } else {
                switch (userEmpresas[0]) {
                    case '1':
                    case 1:
                        setselectedEmpresa("Critério Experts");
                        setEmpresaId(1);
                        break;
                    case '2':
                    case 2:
                        setselectedEmpresa("CRT Adjusters");
                        setEmpresaId(2);
                        break;
                    default:
                        setselectedEmpresa(null);
                        setEmpresaId(null);
                        break;
                }
            }
        }
        asyncFn();
    }, [null, 0, 10]);

    const getEmpresa = (currentValue, value) => {
        if (value === "clear" || value === null) {
            setselectedEmpresa(null);
            setEmpresaId(null);
            return;
        }

        var statusResult = empresaList.filter(function (o) {
            return o.idEmpresa == value;
        });

        var status = statusResult[0].description;
        var idStatus = statusResult[0].idEmpresa;
        setselectedEmpresa(status);
        setEmpresaId(idStatus);
    };

    const filtroEmpresa = async (currentValue, indexTab) => {
        idEmpresa = indexTab;
        setEmpresaId(idEmpresa);

        let formValues = {
            idEmpresa: currentValue,
            dataCorte: dataCorte,
            todosProcessos: todosProcessos
        };
     
        setisLoading(true)
        const result = await getLista(formValues);
        setListaData(result?.data?.list);
        setisLoading(false)

    }

    const handleDataCorteChange = (date) => {
        setDataCorte(date);
    }

    const loadTable = async (data) => {
        if(!idEmpresa) {
            Swal.fire({
                title: "Atenção",
                text: "Informe a Empresa",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return
        }

        if(!dataCorte) {
            Swal.fire({
                title: "Atenção",
                text: "Informe a Data de Corte",
                icon: "warning",
                confirmButtonText: "OK",
            });
            return
        }
        
        let formValues = {
            idEmpresa: idEmpresa,
            dataCorte: dataCorte,
            todosProcessos: todosProcessos
        };

        setisLoading(true)
        const result = await getLista(formValues);
        setListaData(result?.data?.list);
        setTotaisData(result?.data?.totais);
        setSearched(true);
        setisLoading(false);
    }

    const refreshData = async () => {
        let formValues = {
            idEmpresa: idEmpresa,
            dataCorte: dataCorte,
            todosProcessos: true
        };

        loadTable(formValues);
    };

    const getTodosProcessos = (status) => {
        setTodosProcessos(status => !status);
    };
    
    const exportExcel = async () => {
        const visao = "EM_ANDAMENTO";
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("WIP Mensal");
        const imageId2 = workbook.addImage({
            base64: logo,
            extension: 'png',
        });
        worksheet.addImage(imageId2, 'A1:B3');
        worksheet.autoFilter = 'A5:I5';
        worksheet.getRow(5).values = [
            "Laudo",            
            "Nº TS",
            "Disciplina",
            'Horas WIP',
            'Valor WIP',
            'Horas Atual',
            'Valor Atual',
            'Horas Diferença Retroativa',
            'Valor Diferença Retroativa',
        ];
        worksheet.columns = [
            { key: "Laudo", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },            
            { key: "Nº TS", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: "Disciplina", width: 15, style: { alignment: { vertical: 'middle', horizontal: 'left' } } },
            { key: 'Horas WIP', width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: 'Valor WIP', width: 20, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: 'Horas Atual', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: 'Valor Atual', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: 'Horas Diferença Retroativa', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
            { key: 'Valor Diferença Retroativa', width: 30, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
        ];

        worksheet.getRow(5).eachCell((cell) => {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "EE4B21" }, // Cor de fundo (azul escuro)
            };
            cell.font = {
                color: { argb: "FFFFFF" }, // Fonte branca
                bold: true,
                size: 12,
            };
            cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true,
            };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        worksheet.getRow(5).eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });

        ListaData.forEach(atividade => {
            worksheet.addRow({
                "Laudo": atividade.laudo,                
                "Nº TS": atividade.numeroTimesheet,
                "Disciplina": atividade.disciplina,
                "Horas WIP": atividade.horasWip_Passado,
                "Valor WIP": atividade.valorWip_Passado,
                "Horas Atual": atividade.horasTS_Atual,
                "Valor Atual": atividade.valorTS_Atual,
                "Horas Diferença Retroativa": atividade.horasDiferenca_PeriodoLancamento,
                "Valor Diferença Retroativa": atividade.valorDiferenca_PeriodoLancamento,
            });
        });

        const startRow = 6;
        ListaData.forEach((_, index) => {
            const rowNumber = startRow + index;
            worksheet.getRow(rowNumber).eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

        ListaData.forEach((_, index) => {
            const rowNumber = startRow + index;
            worksheet.getRow(rowNumber).getCell(4).numFmt = '#,##0.00';
            worksheet.getRow(rowNumber).getCell(5).numFmt = '[$R$-1] #,##0.00;[Red][$R$-1] -#,##0.00';
            worksheet.getRow(rowNumber).getCell(6).numFmt = '#,##0.00';
            worksheet.getRow(rowNumber).getCell(7).numFmt = '[$R$-1] #,##0.00;[Red][$R$-1] -#,##0.00';
            worksheet.getRow(rowNumber).getCell(8).numFmt = '#,##0.00';
            worksheet.getRow(rowNumber).getCell(9).numFmt = '[$R$-1] #,##0.00;[Red][$R$-1] -#,##0.00';
        });

        worksheet.mergeCells('A1:I4');
        workbook.xlsx.writeBuffer().then(function (data) {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `WIP_MENSAL_${visao}.xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">WIP Mensal</h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card timesheet">
                        <StyledForm onSubmit={handleSubmit(formSubmit)}>
                            
                                <div className="row">
                                    <div className="form-container d-flex flex-column justify-content-center px-0 col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                        <DynamicSelect
                                            placeholder={''}
                                            valuetext={selectedEmpresa}
                                            label={'Selecione a empresa'}
                                            name={'idEmpresa'}
                                            options={empresaList}
                                            keyValue={'idEmpresa'}
                                            keyLabel={'description'}
                                            paramMethod={getEmpresa}
                                            clearOption={true} />
                                    </div>
                                    <div className="form-container d-flex flex-column justify-content-center px-0 col-sm-12 col-md-3 col-lg-3 col-xxl-3">
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={dataCorte}
                                            onChange={handleDataCorteChange}
                                            placeholderText={'Data Corte'}
                                        />
                                    </div>
                                    <div className="form-container d-flex flex-column justify-content-center px-0 col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                        <ToggleSwitchFilters config={toggleTodosProcessos} setStatus={(status) => getTodosProcessos(status)} />
                                    </div>
                                </div>

                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 p-0">
                                    <input type="submit" className='default-button-red' value='Pesquisar' />
                                    {
                                        ListaData?.length > 0 && (<input type="button" className='default-button-red ml-3' value='Exportar' onClick={exportExcel} />)
                                    }
                                </div>
                        </StyledForm>
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                { isLoading ? 
                                    <StldRow>
                                        <div className="text-center">
                                            <div className="align-items-center">
                                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                <div><strong style={{ color: "#EE4B21" }}>Pesquisando...</strong></div>
                                            </div>
                                        </div>
                                    </StldRow>
                                    : 
                                    <StyledTablePage>
                                        <div className="col-xs-6 col-sm-8 col-md-4 col-lg-5 col-xl-5" key={'filterTabs'}></div>
                                        {ListaData && ListaData.length > 0 && (<>
                                            <Tabs className="timesheet m-0" selectedIndex={idEmpresa ?? 2}>
                                                {/* <TabList>
                                                    {empresaList?.length > 1 && (
                                                    <>
                                                        <Tab onClick={() => filtroEmpresa(1, 0)}>Critério Experts</Tab>
                                                        <Tab onClick={() => filtroEmpresa(2, 1)}>Adjusters</Tab>
                                                        <Tab onClick={() => filtroEmpresa(-1, 2)}>Todos</Tab>                                                         
                                                    </>
                                                    )}
                                                </TabList> */}
                                                <table className="table table-bordered table-width table-sm">
                                                    <thead>
                                                        <tr className="table-legend-info">
                                                            <th style={{borderTop: '1px solid #ffffff', borderBottom: '1px solid #ffffff'}} colSpan={2}></th>
                                                            <th style={{borderTop: '1px solid #ffffff', borderBottom: '1px solid #ececec'}} colSpan={4}></th>
                                                            <th style={{borderLeft: '1px solid #ececec'}}>Quantidade TS</th>
                                                            <th style={{borderRight: '1px solid #ececec'}}>{ListaData?.length}</th>
                                                        </tr>
                                                        <tr className="table-legend-info">
                                                            <th style={{borderTop: '1px solid #ffffff'}}></th>
                                                            <th style={{borderTop: '1px solid #ffffff'}}></th>
                                                            <th style={{borderLeft: '1px solid #ececec', borderTop: '1px solid #ececec'}} colSpan={2}>Fotografia</th>
                                                            <th style={{borderLeft: '1px solid #ececec', borderTop: '1px solid #ececec'}} colSpan={2}>Atual</th>
                                                            <th style={{borderLeft: '1px solid #ececec', borderRight: '1px solid #ececec'}} colSpan={2}>Lançamento Retroativo</th>
                                                        </tr>
                                                        <tr className="table-legend-info">
                                                            <th style={{borderLeft: '1px solid #ececec'}}>Laudo</th>
                                                            <th>Nº TS</th>
                                                            <th style={{borderLeft: '1px solid #ececec'}}>Horas</th>
                                                            <th>Valor</th>
                                                            <th style={{borderLeft: '1px solid #ececec'}}>Horas</th>
                                                            <th>Valor</th>
                                                            <th style={{borderLeft: '1px solid #ececec'}}>Horas</th>
                                                            <th style={{borderRight: '1px solid #ececec'}}>Valor</th>
                                                        </tr>
                                                        <tr className="custon-tr-total-lanc">
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center"></td>
                                                            <td className="text-center"><strong></strong></td>
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center"><strong>{TotaisData?.horasWip_Passado}</strong></td>
                                                            <td className="text-center"><strong>{TotaisData?.valorWip_Passado}</strong></td>
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center"><strong>{TotaisData?.horasTS_Atual}</strong></td>
                                                            <td className="text-center"><strong>{TotaisData?.valorTS_Atual}</strong></td>
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center"><strong>{TotaisData?.horasDiferenca_PeriodoLancamento}</strong></td>
                                                            <td style={{borderRight: '1px solid #ececec'}} className="text-center"><strong>{TotaisData?.valorDiferenca_PeriodoLancamento}</strong></td>
                                                        </tr> 
                                                    </thead>
                                                    <tbody>
                                                    { ListaData?.map((atividade, index) => (
                                                        <tr key={index}>
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center text-no-wrap">{atividade.laudo}</td>
                                                            <td className="text-center text-no-wrap">{atividade.numeroTimesheet}</td>
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center text-no-wrap">{atividade.horasWip_Passado.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2,})}</td>
                                                            <td className="text-center text-no-wrap">{atividade.valorWip_Passado.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2,})}</td>
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center text-no-wrap">{atividade.horasTS_Atual.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2,})}</td>
                                                            <td className="text-center text-no-wrap">{atividade.valorTS_Atual.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2,})}</td>
                                                            <td style={{borderLeft: '1px solid #ececec'}} className="text-center text-no-wrap">{atividade.horasDiferenca_PeriodoLancamento.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2,})}</td>
                                                            <td style={{borderRight: '1px solid #ececec'}} className="text-center text-no-wrap">{atividade.valorDiferenca_PeriodoLancamento.toLocaleString('pt-BR', {minimumFractionDigits: 2,maximumFractionDigits: 2,})}</td>
                                                        </tr>
                                                        )
                                                    )}
                                                    </tbody>
                                                </table>
                                            </Tabs>
                                            </>)
                                        }
                                    </StyledTablePage>
                                }
                                </StyledForm>
                            </Flex>
                        </StldRow>
                    </div>
                </StyledDefaultPage>
            </main>
        </section>
    );
}

export const WIPMensalPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <WIPMensal />    
                </>
            )}
        </>
    );
}